import { useMemo } from "react";
import useSettingsConfig from "../../../hooks/useSettingsConfig";
import { TableCell, TableRow } from "@mui/material";
import { getArrayIsNotEmpty } from "../../../../SharedComponents/utils/helpers/getArrayIsNotEmpty";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import { getSecondsFromStringTime } from "../../../../SharedComponents/utils/helpers/dateHelpers";
import DynamicTimeLabel from "../../Labels/DynamicTimeLabel";
import { useNavigate } from "react-router-dom";

const MessagesInRequestTableRow = ({
    partOffer
}) => {
    const navigate = useNavigate();

    const GetImageComponent = () => {
        let imgSource = '';

        const imagesArray = partOffer.PartRequest.PartRequestImages;

        const requestHaveImages = getArrayIsNotEmpty(imagesArray);

        if (requestHaveImages) {
            imgSource = imagesArray[0].small_part_request_image_url;
        };

        const ImageComponent = (
            <div style={styles.imageContainer}>
                <img
                    src={imgSource}
                    style={styles.imageStyle}
                />
            </div>
        );

        return imgSource
            ? ImageComponent
            : <div />
    };


    const GetDynamicTextLabelCell = () => {
        const { settingsConfig } = useSettingsConfig();

        const collectOffersTime = useMemo(
            () => getSecondsFromStringTime(settingsConfig?.part_request_accepting_offers_time_value, settingsConfig?.part_request_accepting_offers_time_part),
            [settingsConfig]
        );


        const selectWinnerTime = useMemo(
            () => getSecondsFromStringTime(settingsConfig?.part_request_selecting_offer_time_value, settingsConfig?.part_request_selecting_offer_time_part),
            [settingsConfig]
        );


        return (
            <DynamicTimeLabel
                createdAt={partOffer.PartRequest.createdAt}
                state={partOffer.PartRequest.state}
                collectOffersTime={collectOffersTime}
                selectWinnerTime={selectWinnerTime}
            />
        );
    };

    const getOffererName = () => {
        const userFirstName = partOffer.User.firstname;
        const userLastName = partOffer.User.lastname;

        return `${userFirstName} ${userLastName}`;
    };

    const handleRedirect = () => {
        const partOfferId = partOffer.PartRequest.part_request_id;

        const breadcrumbs = [
            { title: "Pocetak", href: "/home" },
            { title: "Poruke", href: "/messages" },
            { title: partOffer.title }
        ];

        const breadcrumbsQuery = encodeURIComponent(JSON.stringify(breadcrumbs));

        navigate(`/part-offer/${partOfferId}?breadcrumbs=${breadcrumbsQuery}`);
    };

    const GetUnReadMessagesCounterComponent = () => {
        const hasUnseenMessages = (partOffer.unreadMessageCount > 0);

        const CounterVisualizer = (
            <div style={styles.counterVisualizerContainer}>
                <p style={styles.counterVisualizerText}>
                    {partOffer.unreadMessageCount}
                </p>
            </div>
        );

        return hasUnseenMessages
            ? CounterVisualizer
            : <div />
    };


    return (
        <TableRow
            onClick={() => handleRedirect()}
            sx={{ cursor: 'pointer' }}
        >
            <TableCell>
                {GetUnReadMessagesCounterComponent()}
            </TableCell>

            <TableCell>
                {GetImageComponent()}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {partOffer.PartRequest.title}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {GetDynamicTextLabelCell()}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {partOffer.PartRequest.description}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {getOffererName()}
            </TableCell>

        </TableRow>
    );
};


export default MessagesInRequestTableRow;

const styles = {
    imageContainer: {
        width: 32,
        height: 32,
        borderRadius: 4
    },
    imageStyle: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 4
    },
    textStyle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        color: "rgba(0,0,0,0.87)"
    },
    counterVisualizerContainer: {
        backgroundColor: '#FF0000',
        width: 24,
        height: 24,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    counterVisualizerText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "14px",
        color: '#FFFFFF',
    }
};